// src/components/CommonSidebar.js
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useEffect, useState } from 'react';
import './CommonSidebar.css';

function CommonSidebar({ 
  isOpen, 
  onToggle, 
  userType, 
  menuItems,
  logoText = { primary: "ADAM", secondary: "AKADEMİ" }
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isActive = (path, exact = false) => {
    if (exact && location.pathname === path) return 'active';
    if (!exact && location.pathname.startsWith(path)) return 'active';
    return '';
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleNavClick = () => {
    if (isMobile) {
      onToggle();
    }
  };

  // Rol bazlı tema renkleri
  const getRoleColor = () => {
    switch(userType) {
      case 'admin': return '#B22234'; // Kırmızı
      case 'teacher': return '#1E4A7A'; // Açık lacivert
      case 'student': return '#0B2A4A'; // Lacivert
      default: return '#B22234';
    }
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isMobile && isOpen && (
        <div 
          className="sidebar-overlay-mobile"
          onClick={onToggle}
        />
      )}
      
      <div className={`common-sidebar-container ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <nav className="common-sidebar" style={{ '--sidebar-accent': getRoleColor() }}>
          {/* Header */}
          <div className="sidebar-header">
            <div className="sidebar-logo">
              <div className="logo-icon">🎓</div>
              <div className="logo-text">
                <span className="logo-primary">{logoText.primary}</span>
                <span className="logo-secondary">{logoText.secondary}</span>
              </div>
            </div>
            {!isMobile && (
              <button className="sidebar-toggle" onClick={onToggle}>
                {isOpen ? '‹' : '›'}
              </button>
            )}
          </div>

          {/* User Info */}
          <div className="user-info">
            <div className="user-avatar">
              {user?.name?.charAt(0)?.toUpperCase() || userType?.charAt(0)?.toUpperCase() || 'U'}
            </div>
            <div className="user-details">
              <span className="user-name">{user?.name || userType}</span>
              <span className="user-role">
                {userType === 'admin' && 'Yönetici'}
                {userType === 'student' && 'Öğrenci'}
                {userType === 'teacher' && 'Öğretmen'}
              </span>
            </div>
          </div>

          {/* Navigation */}
          <ul className="sidebar-nav">
            {menuItems.map((item) => (
              <li key={item.path} className="nav-item">
                <Link 
                  to={item.path} 
                  className={`nav-link ${isActive(item.path, item.exact)}`}
                  onClick={handleNavClick}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-text">{item.label}</span>
                  <div className="active-indicator"></div>
                </Link>
              </li>
            ))}
          </ul>

          {/* Footer */}
          <div className="sidebar-footer">
            <button onClick={handleLogout} className="logout-btn">
              <span className="logout-icon">🚪</span>
              <span className="logout-text">Log Out</span>
            </button>
          </div>
        </nav>
      </div>

      {/* Floating Toggle Button for Mobile */}
      {!isOpen && isMobile && (
        <button className="sidebar-toggle-floating" onClick={onToggle}>
          ☰
        </button>
      )}
    </>
  );
}

export default CommonSidebar;